import {
  FormikProps,
  ProductsSequence,
  type ProductsSequenceProduct,
  type ProgressBar,
  type TimeFrameObject
} from 'common/contracts';

export interface IProgressBarFormProps {
  edit?: boolean;
  dup?: boolean;
}

export interface IProgressBarProduct {
  _id: string;
  productId: string;
  image: string;
  imagePrefix: string;
  name: string;
  amount: number | string;
  type: string;
  textFontColorHex: string;
  prefix: string;
  suffix: string;
  publisherProductId?: string;
  quantityDisplay: string;
  priority?: string;
}

export interface IProgressBarSequenceProps {
  productsSequence: ProductsSequence[];
  setProductsSequence: React.Dispatch<React.SetStateAction<ProductsSequence[]>>;
}

export interface IProgressBarProductsProps {
  hasMissingProductDetails?: boolean;
  products?: IProgressBarProduct[];
  setProducts?: (products: IProgressBarProduct[]) => void;
  setDirtyProducts?: (isDirty: boolean) => void;
  setCurrentProduct?: (product: ProductsSequenceProduct | null) => void;
  isLoadingProducts?: boolean;
}

export interface IProgressBarTabProps
  extends IProgressBarFormProps,
    IProgressBarSequenceProps,
    IProgressBarProductsProps {
  formikProps: FormikProps;
  progressBarId?: string;
}

export interface IProgressBarSchedule {
  permanent: boolean;
  interval?: string;
  timeFrames?: TimeFrameObject[];
}

export interface IProgressBarOfferUi {
  offerUiId?: string;
  _id?: string;
  active: boolean;
  offerUiType: string;
  name: string;
  description: string;
  backgroundImage: string;
  progressBar: ProgressBar;
}

export type ProgressBarRowData = {
  publisherOfferId: string;
  offerId: string;
  productsSequence: ProductsSequence[];
  status: string;
  active: boolean;
  schedule?: IProgressBarSchedule;
  offerUi?: IProgressBarOfferUi;
};

export enum EProgressBarTabs {
  SETTINGS = 'Settings',
  CONFIGURATION = 'Configuration',
  SCHEDULE = 'Schedule'
}
